import React, {useState} from "react"
import {useParams} from "react-router-dom"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import {useAccessToken} from "../../services/auth"
import {OkDocument} from "../../resources/common"
import {useRefreshToken} from "../../hooks/useRefreshToken"
import {
	Application,
	DeviceFingerprints,
	getApplication,
	isBusinessApplicationDocument,
	isIndividualApplicationDocument,
} from "../../resources/application"
import BusinessApplication from "../BusinessApplication/BusinessApplication"
import IndividualApplication from "../IndividualApplication/IndividualApplication"
import Icon from "../../components/Icon/Icon"
import Drawer from "../../components/Drawer/Drawer"
import ReactJson from "react-json-view"

function ApplicationInternal({value: application, refresh}: {value: OkDocument<Application>; refresh: () => void}) {
	if (isBusinessApplicationDocument(application)) {
		return <BusinessApplication value={application} refresh={refresh} />
	}
	if (isIndividualApplicationDocument(application)) {
		return <IndividualApplication value={application} refresh={refresh} />
	}
	return <React.Fragment />
}

export function ApplicationDeviceInfo(deviceFingerprints: DeviceFingerprints) {
	const [isDeviceInfoOpen, setIsDeviceInfoOpenOpen] = useState(false)
	const toggleDeviceInfo = () => {
		setIsDeviceInfoOpenOpen((prevState) => !prevState)
	}

	return (
		<div className="card">
			<div className="card-content">
				<div className="application-page-device-info-box" onClick={toggleDeviceInfo}>
					Device Info <Icon icon="maximize-square-4--interface-essential" size={16} />
				</div>
				<Drawer
					open={isDeviceInfoOpen}
					onClose={toggleDeviceInfo}
					direction="right"
					className="account-side-drawer"
					title={"Device Info"}
				>
					<div className="p-4" style={{width: 800}}>
						<ReactJson src={deviceFingerprints}></ReactJson>
					</div>
				</Drawer>
			</div>
		</div>
	)
}

export default function ApplicationPage() {
	const {applicationId = ""} = useParams<{applicationId: string}>()
	const accessToken = useAccessToken()
	const [refreshToken, refresh] = useRefreshToken()
	const asyncResultApplication = useAsyncResult(() => getApplication(accessToken, applicationId), [refreshToken])

	return (
		<AsyncResultComponent asyncResult={asyncResultApplication} refresh={refresh}>
			{({value}) => {
				return <ApplicationInternal value={value as OkDocument<Application>} refresh={refresh} />
			}}
		</AsyncResultComponent>
	)
}
